import httpManager from "@/app/shared/utils/httpManager";

export async function fetchCustomerAvailableReports() {
  const url = `/reports/`;

  const response = await httpManager.get(url);
  return response?.data;
}
